import React, { useState, useEffect } from 'react'
import { Button } from './ui/Button'
import {Download, X} from 'lucide-react'
import { promptInstall, isAppInstalled } from '../utils/pwaInstaller'

export function InstallPrompt() {
  const [showPrompt, setShowPrompt] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    // Check if already installed or dismissed
    const isDismissed = localStorage.getItem('installPromptDismissed')
    if (isAppInstalled() || isDismissed) {
      return
    }

    // Show prompt after 30 seconds of usage
    const timer = setTimeout(() => {
      setShowPrompt(true)
    }, 30000)

    return () => clearTimeout(timer)
  }, [])

  const handleInstall = async () => {
    const installed = await promptInstall()
    if (installed) {
      setShowPrompt(false)
    }
  }

  const handleDismiss = () => {
    setShowPrompt(false)
    setDismissed(true)
    localStorage.setItem('installPromptDismissed', 'true')
  }

  if (!showPrompt || dismissed) {
    return null
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-white border-2 border-red-500 rounded-lg shadow-2xl p-4 z-50 animate-slide-up">
      <button
        onClick={handleDismiss}
        className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
      >
        <X className="h-4 w-4" />
      </button>
      
      <div className="flex items-start space-x-3">
        <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
          <Download className="h-6 w-6 text-red-600" />
        </div>
        
        <div className="flex-1">
          <h3 className="font-bold text-gray-900 mb-1">
            Instalar Doe no seu celular
          </h3>
          <p className="text-sm text-gray-600 mb-3">
            Acesso rápido, notificações de pedidos urgentes e funciona offline!
          </p>
          
          <div className="flex space-x-2">
            <Button
              onClick={handleInstall}
              className="flex-1 bg-red-600 hover:bg-red-700 text-white text-sm h-9"
            >
              <Download className="h-4 w-4 mr-2" />
              Instalar Agora
            </Button>
            <Button
              onClick={handleDismiss}
              variant="outline"
              className="text-sm h-9 px-3"
            >
              Agora não
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
